// Omit a number or string value from an object
// const newObj = omit(oldObj, 'key');
// const newObj = omit(oldObj, id);
export const omit = (items, omitKey) =>
  Object.keys(items).reduce((curr, key) => {
    if (key === `${omitKey}`) return curr;
    curr[key] = items[key];
    return curr;
  }, {});
